import { PageHead } from '../components/ui';
import { MaIntegrationPlan } from './ma/MaIntegrationPlan';

/**
 * The M&A Integration Plan on its own page (migration 163), so it can be
 * granted to the people working an integration without the rest of M&A.
 * Lists an admin marks Admins only never reach anyone else — the API leaves
 * them out — and the plan's shape (plans, lists, templates) stays the admins'.
 */
export function IntegrationPlanPage({ isAdmin }: { isAdmin: boolean }) {
  return (
    <>
      <PageHead
        title="Integration Plan"
        lede="The post-close integration board: each list is a workstream, each card a step with its owner, dates and checklist."
      />
      <MaIntegrationPlan isAdmin={isAdmin} />
    </>
  );
}
